import { createFileRoute } from "@tanstack/react-router";
import { useRequireRole } from "@/lib/use-require-role";
import { PageHeader } from "@/components/page-header";
import { plans, fmtCents, organizations } from "@/mocks/saas-data";
import { Check } from "lucide-react";

export const Route = createFileRoute("/admin/plans")({
  ssr: false,
  head: () => ({ meta: [{ title: "Admin — Plans" }] }),
  component: Page,
});

function Page() {
  const user = useRequireRole(["superadmin"]);
  if (!user) return null;

  return (
    <div className="mx-auto max-w-6xl px-6 py-8 lg:px-10 lg:py-10">
      <PageHeader title="Plans" description="Subscription tiers and limits." />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {plans.map((p) => {
          const orgsOnPlan = organizations.filter((o) => o.planId === p.id).length;
          return (
            <div key={p.id} className="rounded-xl bg-card p-6 ring-1 ring-border">
              <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{orgsOnPlan} orgs</p>
              <h3 className="mt-1 text-lg font-semibold">{p.name}</h3>
              <p className="mt-1 font-mono text-2xl font-semibold">{fmtCents(p.priceCents)}<span className="text-xs font-normal text-muted-foreground">/{p.interval}</span></p>
              <ul className="mt-4 space-y-1.5 text-sm">
                <li>{p.limits.seats} seats</li>
                <li>{p.limits.storageGb} GB storage</li>
                <li>{p.limits.shootsPerMonth} shoots/month</li>
              </ul>
              <ul className="mt-4 space-y-1.5 border-t border-border pt-4 text-xs">
                {(Object.entries(p.features) as [keyof typeof p.features, boolean][]).map(([k, v]) => (
                  <li key={k} className={`flex items-center gap-2 ${v ? "text-foreground" : "text-muted-foreground line-through"}`}>
                    <Check className={`size-3.5 ${v ? "text-success" : "text-muted-foreground/40"}`} /> {k.replace(/([A-Z])/g, " $1")}
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  );
}
